module.exports = __webpack_public_path__ + "static/img/02_08_reverb.5595d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/02_08_reverb.png
// module id = PZUR
// module chunks = 13